import React from "react";
import hljs from "highlight.js/lib/core";
import "highlight.js/styles/github.css";
import { Box, useTheme } from "@mui/material";

import xml from "highlight.js/lib/languages/xml";
import json from "highlight.js/lib/languages/json";
import javascript from "highlight.js/lib/languages/javascript";
import typescript from "highlight.js/lib/languages/typescript";
import css from "highlight.js/lib/languages/css";
import html from "highlight.js/lib/languages/xml"; // HTML uses XML mode
import bash from "highlight.js/lib/languages/bash";
import sql from "highlight.js/lib/languages/sql";
import yaml from "highlight.js/lib/languages/yaml";
import plaintext from "highlight.js/lib/languages/plaintext";

hljs.registerLanguage("xml", xml);
hljs.registerLanguage("html", html);
hljs.registerLanguage("json", json);
hljs.registerLanguage("js", javascript);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("ts", typescript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("css", css);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("text", plaintext);

type CodeViewerProps = {
  code: string;
  language?: string;
};

const CodeViewer: React.FC<CodeViewerProps> = ({ code, language = "text" }) => {
  const theme = useTheme();

  const highlighted = React.useMemo(() => {
    try {
      return hljs.highlight(code, { language }).value;
    } catch {
      return hljs.highlightAuto(code).value;
    }
  }, [code, language]);

  return (
    <Box
      component="pre"
      sx={{
        textAlign: "left",
        overflowX: "auto",
        backgroundColor: theme.palette.mode === "dark" ? "#1e1e1e" : "#f6f8fa",
        borderRadius: 1,
        p: 2,
        fontFamily: "monospace",
        fontSize: "0.875rem",
        lineHeight: 1.5,
        "& .hljs": {
          color: theme.palette.text.primary,
        },
        "& .hljs-tag": { color: theme.palette.primary.main },
        "& .hljs-attr": { color: theme.palette.secondary.main },
        "& .hljs-string": { color: theme.palette.success.main },
        "& .hljs-keyword": { color: theme.palette.info.main },
        "& .hljs-comment": { color: theme.palette.text.disabled },
      }}
      dangerouslySetInnerHTML={{ __html: highlighted }}
    />
  );
};

export default CodeViewer;
